var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8906 45.6029C35.317 45.6029 45.3906 35.5293 45.3906 23.1029C45.3906 10.6765 35.317 0.602905 22.8906 0.602905C10.4642 0.602905 0.390625 10.6765 0.390625 23.1029C0.390625 35.5293 10.4642 45.6029 22.8906 45.6029Z",
    fill: "#2350F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 12.6029L14 16.6029V22.6029C14 28.1529 17.84 33.3429 23 34.6029C28.16 33.3429 32 28.1529 32 22.6029V16.6029L23 12.6029ZM23 23.5929H30C29.47 27.7129 26.72 31.3829 23 32.5329V23.6029H16V17.9029L23 14.7929V23.5929Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShield);
export default __webpack_public_path__ + "static/media/icon-shield.f5d792e4490c5f9887960d21d0822b75.svg";
export { ForwardRef as ReactComponent };